export default __webpack_public_path__ + "welcome-banner-promo-art-light.8981537b.svg";